/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SquadAuditLogEnum {
    TRANSFER_PLAYER = 'transfer_player',
    PATCH_PLAYER = 'patch_player',
    CREATE_PLAYER = 'create_player',
    START_PLAYER = 'start_player',
    STOP_PLAYER = 'stop_player',
    TRANSFER_COACH = 'transfer_coach',
    PATCH_COACH = 'patch_coach',
    CREATE_COACH = 'create_coach',
    START_COACH = 'start_coach',
    STOP_COACH = 'stop_coach',
}
